import React from 'react';
import PropTypes from 'prop-types';

import { Bert } from 'meteor/themeteorchef:bert';
import { Grid, Fab, Box, Typography, Stack, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { isEmpty } from 'lodash';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import useTimeStore from '../../ZustandProvider';

import TemplatePointCloudItemEdit from './TemplatePointCloudItemEdit';

import * as templateOps from '../../../../api/AnnotationTemplates/annotation-template-operations';
import * as annotationOps from '../../../../api/Annotations/annotation-operations';

import OpenModalFromUrl from '../../OpenModalFromUrl';

const EDITION_MODE = 'edition';
const PREVIEW_MODE = 'preview';

const TemplatePointCloudItem = ({
  elementItem,
  previewMode,
  updateAnnotationFields,
  deployEnv,
  isNotesComponent,
  ...rest
}) => {
  const coordOnMap = useTimeStore(state => state.coordOnMap);
  const { selectedAnnotation, annotation } = rest;
  const [connections, setConnections] = React.useState(
    templateOps.getElementConnections(elementItem)
  );
  const [viewLinkSelected, setViewLinkSelected] = React.useState('');
  const [linkSelected, setLinkSelected] = React.useState({});
  const [source, setSources] = React.useState(connections.source);
  const [openFullScreen, setOpenFullScreen] = React.useState(false);
  const { server = {} } = connections;

  const useStyles = makeStyles(() => ({
    fabWithPhoto: {
      position: 'relative',
      overflow: 'hidden',
      borderRadius: '50%',
      width: '56px',
      height: '56px'
    },
    photo: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  }));
  const classes = useStyles();

  const getLinkLidarMap = async row => {
    const urlFunction = () => {
      let url;
      if (server.serverType === 'IGP') {
        url = `http://${server.ip}:${server.port}/MG/lidar/write_lidar_html`;
      } else if (server.serverType === 'IGPS' || server.serverType === 'input') {
        url = `${server.domain}/MG/lidar/write_lidar_html`;
      }
      return url;
    };

    let coords = {};
    if (deployEnv === 'gmv' && !isNotesComponent) {
      if (!isEmpty(annotation)) {
        const { coordinates } = annotation.geoJSON.geometry;
        coords = { lat: coordinates[1], lng: coordinates[0] };
      }
    }
    if (isNotesComponent) {
      if (!isEmpty(coordOnMap) && previewMode === EDITION_MODE) {
        coords = coordOnMap;
      }
      if (!isEmpty(selectedAnnotation) && previewMode === PREVIEW_MODE) {
        const geoJSONAnnotations = annotationOps.getGeoJSON(selectedAnnotation);
        const { coordinates } = geoJSONAnnotations.geometry;
        coords = { lat: coordinates[1], lng: coordinates[0] };
      }
    }
    if (!isEmpty(coords)) {
      try {
        const response = await fetch(urlFunction(), {
          method: 'POST',
          body: JSON.stringify({
            disc: 'data3',
            ftpIp: '',
            ftpPort: '',
            ftpUser: '',
            ftpPassword: '',
            httpPort: '',
            projectsEntwine: [row.path],
            projectName: '',
            projectPath: 'htmls/lidar/tempwines',
            position: [coords.lat, coords.lng],
            user: ''
          }),
          headers: { 'Content-Type': 'application/json' },
          mode: 'cors',
          credentials: 'omit',
          referrerPolicy: 'no-referrer'
        });

        const respuesta = await response.json();
        setViewLinkSelected(respuesta.htmlCreated);
      } catch (error) {
        Bert.alert('No se encuentra mapa en estas coordenadas', 'error');
      }
    } else {
      Bert.alert('Selecciona un punto del mapa', 'warning');
    }
  };

  React.useEffect(() => {
    if (!isEmpty(connections) && previewMode === EDITION_MODE)
      updateAnnotationFields(elementItem, 'connections', connections);
  }, [connections]);

  React.useEffect(() => {
    if (!isEmpty(elementItem)) {
      const connectionsItem = templateOps.getElementConnections(elementItem);
      const sourcesItem = connectionsItem.source;
      setSources(sourcesItem);
      setViewLinkSelected('');
      setLinkSelected({});
    }
  }, [elementItem]);
  const nameLink = !isEmpty(linkSelected)
    ? linkSelected.name.substring(0, linkSelected.name.lastIndexOf('.'))
    : '';

  return (
    <>
      {previewMode === PREVIEW_MODE && (
        <Box
          height={!isEmpty(viewLinkSelected) ? '50vh' : '10vh'}
          position="relative"
          marginBottom={!isEmpty(viewLinkSelected) ? '20%' : 0}
        >
          <Grid justifyContent="space-around" alignItems="stretch" mb={2}>
            <>
              {!isEmpty(linkSelected) && (
                <Typography variant="h5" fontWeight="bold">
                  {nameLink}
                </Typography>
              )}
              {!isEmpty(source) && (
                <Stack direction="row" justifyContent="flex-around">
                  {source.map(item => {
                    return (
                      <>
                        <Fab
                          key={item}
                          color="primary"
                          aria-label="add"
                          onClick={() => {
                            getLinkLidarMap(item);
                            setLinkSelected(item);
                          }}
                          className={classes.fabWithPhoto}
                          title={item.name}
                        >
                          <img
                            alt="streetView"
                            src="https://cdn-icons-png.flaticon.com/512/9218/9218848.png"
                            className={classes.photo}
                          />
                        </Fab>
                      </>
                    );
                  })}
                </Stack>
              )}
            </>
          </Grid>
          {!isEmpty(viewLinkSelected) && (
            <>
              <Box
                style={{
                  position: 'relative',
                  width: '100%',
                  height: '100%'
                }}
              >
                <Box
                  style={{ zIndex: 'tooltip', position: 'absolute', width: '100%', height: '100%' }}
                >
                  <iframe
                    title="WebPage"
                    src={viewLinkSelected}
                    style={{ width: '100%', height: '100%' }}
                  />
                </Box>
                <Box
                  style={{
                    zIndex: 'modal',
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    top: '90%'
                  }}
                >
                  <IconButton
                    style={{
                      color: 'white',
                      size: 'lg'
                    }}
                    onClick={() => setOpenFullScreen(true)}
                  >
                    <FullscreenIcon />
                  </IconButton>
                </Box>
              </Box>
              <OpenModalFromUrl
                isFullScreen
                isImage={false}
                isLoading
                openModal={openFullScreen}
                setOpenModal={setOpenFullScreen}
                url={viewLinkSelected}
                title={nameLink}
              />
            </>
          )}
        </Box>
      )}
      {previewMode === EDITION_MODE && (
        <>
          <TemplatePointCloudItemEdit connections={connections} setConnections={setConnections} />
        </>
      )}
    </>
  );
};
TemplatePointCloudItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update'),
  deployEnv: 'gmv',
  isNotesComponent: false
};

TemplatePointCloudItem.propTypes = {
  previewMode: PropTypes.string.isRequired,
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  deployEnv: PropTypes.string,
  isNotesComponent: PropTypes.bool
};

export default TemplatePointCloudItem;
